import { Address, Contact } from '@hdms/shared/common-types';
import { UserContextService } from '@hdms/shared/data-access';

export enum ModeType {
  QA = 'QA',
  AM = 'AM',
  EV = 'EV'
}

export enum ModeClass {
  QA = 'is-qa-mode',
  AM = 'is-ts-mode'
}

export type ModeAmData = Pick<Address, 'company' | 'company2'> &
  Pick<Contact, 'firstName' | 'lastName'> &
  Pick<UserContextService, 'preselectedShipToId'>;

export type ModeEvData = Pick<Contact, 'formatted'>;

export interface ModeQaData {
  label: string;
}

export interface HeaderMode<T = Partial<ModeEvData & ModeAmData & ModeQaData>> {
  type: ModeType;
  class?: ModeClass;
  data?: T;
}
